// import Vue from 'vue'
// import consts from "@/consts"
// import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
import consts from "@/consts";
import range from "lodash/range";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed__time';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

export default {
    state: {
        shipmentsFullLoad: false,
        shipmentsLiteLoad: false,
        shipments: [],
    },
    actions: {
        fetchShipmentsAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isShipmentsLiteLoad) {
                    return resolve(getters.getShipments.length)
                }
                this.$api.init.getShipments()
                    .then((response) => {
                        if (response.status < 400 && response.data?.shipments) {
                            commit('updateShipments', response.data.shipments)
                            commit('setShipmentsLiteLoad', true)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                           dispatch('fetchShipmentsAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchShipments/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchShipments', args, time: Date.now() / 1000})

                const params = getApiProps('shipments', args)
                this.$api.shipments.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error && !response.data?.errors) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipments', args, inprogress: false})
                    });
            })
        },
        fetchShipment/*all*/({dispatch, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                let args = {id}
                dispatch('setLastCall', {name: 'fetchShipment', args, time: Date.now() / 1000})

                const params = getApiProps('shipments', args)
                this.$api.shipments.find(id,{...params})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error && !response.data.errors) {
                            commit('updateShipment', response?.data)
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchShipment', args, inprogress: false})
                    });
            })
        },

        fetchShipmentsAll({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isShipmentsLiteLoad) {
                    return resolve(getters.getShipments.length)
                }
                dispatch('fetchShipments', {lite: true})
                    .then((data) => {
                        commit('updateShipments', data)
                        commit('setShipmentsLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchShipmentsAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchShipmentsAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchShipmentsAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchShipmentsChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(null)
                }
                if (!getters.getShipments.length) {
                    return resolve([])
                }
                let pageSize = consts.querySettings.pageSize
                let pages = Math.ceil(getters.getShipments.length / pageSize)
                let fetch = range(pages).map(i => {
                    let page = i + 1;
                    return dispatch('fetchShipments', {page, 'page-size': pageSize, ...args})
                        .then((data) => {
                            commit('updateShipments', data)
                        })
                        .catch(() => {
                            dispatch('fetchShipments', {page, 'page-size': pageSize, ...args})
                        })
                });
                resolve(fetch)
            })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setShipmentsFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchShipmentsAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchShipmentsChanged', args, inprogress: false})
                })
        },
        fetchShipmentsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isShipmentsFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchShipmentsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchShipments', args)
                .then((data) => {
                    commit('updateShipments', data)
                    return dispatch('fetchShipments', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterShipments', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchShipmentsChanged', args, inprogress: false})
                });
        },
        fetchFavoritesShipments({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchFavoritesShipments', args, time: Date.now() / 1000})

                dispatch('fetchShipments', {filter: {favorites: true}})
                    .then((data) => {
                        commit('updateShipments', data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchFavoritesShipments', args, inprogress: false})
                    });
            })
        },

        reloadShipmentsAll({commit, dispatch}, args) {
            commit('clearShipments')
            return dispatch('fetchShipmentsAllLite', args)
                .then(() => {
                    dispatch('fetchShipmentsAllPages', args)
                })
        },

        saveShipment({dispatch}, shipment) {
            let fn = (shipment.id) ? 'updateShipment' : 'createShipment'
            return dispatch(fn, shipment);
        },
        createShipment({dispatch, commit}, shipment) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipments')
                this.$api.shipments.create(shipment, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error && !response.data.errors) {
                            commit('updateShipment', response?.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    })
                    .finally(() => {
                        dispatch('fetchShipmentsPackagesChanged')
                        dispatch('fetchShipmentsChanged')
                        dispatch('fetchShipmentsDevices')
                    });
            })
        },
        updateShipment({dispatch, commit}, shipment) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipments')
                this.$api.shipments.update(shipment.id, shipment, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error && !response.data.errors) {
                            commit('updateShipment', response?.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    })
                    .finally(() => {
                        dispatch('fetchShipmentsPackagesChanged')
                        dispatch('fetchShipmentsChanged')
                        dispatch('fetchShipmentsDevices')
                    });
            })
        },
        completeShipment({dispatch}, shipmentId) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipments')
                this.$api.shipments.completeShipment(shipmentId, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && response?.data && !response?.data?.error && !response?.data?.errors) {
                            dispatch('fetchShipment', response.data.id)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    })
                    .finally(() => {
                        dispatch('fetchShipmentsPackagesChanged')
                        dispatch('fetchShipmentsChanged')
                        dispatch('fetchShipmentsDevices')
                    });
            })
        },
        deleteShipment({dispatch, commit}, shipmentId) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('shipments')
                this.$api.shipments.delete(shipmentId, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && !response?.data?.error && !response?.data?.errors) {
                            if (!response.data.id) commit('deleteShipment', shipmentId)
                            else commit('updateShipment', response?.data?.id)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    })
                    .finally(() => {
                        dispatch('fetchShipmentsPackagesChanged')
                        dispatch('fetchShipmentsChanged')
                        dispatch('fetchShipmentsDevices')
                    });
            })
        },
    },
    mutations: {
        setShipmentsFullLoad(state, FullLoad) {
            state.shipmentsFullLoad = state.shipmentsFullLoad || FullLoad
        },
        setShipmentsLiteLoad(state, LitaLoad) {
            state.shipmentsLiteLoad = state.shipmentsLiteLoad || LitaLoad
        },

        setShipments(state, nShipments) {
            nShipments = nShipments.map(s => {
                if (s?.name) s.name_ = s.name.toLocaleLowerCase()
                return s //Object.freeze(s)
            })
            nShipments.sort(sortByName)
            state.shipments = nShipments
        },

        updateShipments(state, nShipments) {
            if (!state.shipments.length) {
                nShipments = nShipments.map(s => {
                    if (s?.name) s.name_ = s.name.toLocaleLowerCase()
                    return s //Object.freeze(s)
                })
                //nShipments.sort(sortByName)
                state.shipments = nShipments
                // const chunks = arraySplitIntoChunks(nShipments)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.shipments.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            nShipments.forEach(function (nShipment) {
                if (nShipment?.name) nShipment.name_ = nShipment.name.toLocaleLowerCase()
                let i = state.shipments.findIndex(s => (s.id == nShipment.id))
                if (i < 0) {
                    state.shipments.push(nShipment) //(Object.freeze(nShipment))
                } else
                if (!state.shipmentsFullLoad || (state.shipments[i][changedField] != nShipment[changedField] && state.shipments[i][changedField]>0)) {
                    updateObjectByDiff(state.shipments[i], nShipment)
                    // delete nShipment.id
                    // nShipment = {...state.shipments[i], ...nShipment}
                    // state.shipments[i] = nShipment //Object.freeze(nShipment)
                }
            })

        },
        filterShipments(state, nShipments) {
            // let Ids = state.shipments.map(s=> s.id)
            let nIds = nShipments.map(s => s.id)
            let removedIds = state.shipments.filter(s => s.id > 0 && !nIds.includes(s.id)).map(s => s.id)
            removedIds.forEach(removedId => {
                let i = state.shipments.findIndex(s => (s.id == removedId))
                if (i != -1) {
                    state.shipments.splice(i, 1)
                }
            })
        },
        updateShipment(state, nShipment) {
            if (nShipment?.name) nShipment.name_ = nShipment.name.toLocaleLowerCase()
            let i = state.shipments.findIndex(s => (s.id == nShipment.id))
            if (i < 0) {
                state.shipments.push(nShipment) //(Object.freeze(nShipment))
            } else
            // if (state.shipmentsFullLoad || (state.shipments[i][changedField] != nShipment[changedField])) && state.shipments[i][changedField]>0
            {
                updateObjectByDiff(state.shipments[i], nShipment)
                // delete nShipment.id
                // nShipment = {...state.shipments[i], ...nShipment}
                // state.shipments[i] = nShipment //Object.freeze(nShipment)
            }
        },
        deleteShipment(state, shipmentId) {
            let i = state.shipments.findIndex(s => (s.id == shipmentId))
            if (i != -1) {
                state.shipments.splice(i, 1)
            }
        },

        clearShipments(state) {
            state.shipments = []
            state.shipmentsFullLoad = false
            state.shipmentsLiteLoad = false
        },
    },
    getters: {
        isShipmentsFullLoad(state) {
            return state.shipmentsFullLoad
        },
        isShipmentsLiteLoad(state) {
            return state.shipmentsLiteLoad
        },
        getShipmentsFullLoadById(state) {
            return state.shipments.reduce((out, shipment) => {
                out[shipment.id] = (typeof shipment[changedField] !== 'undefined')
                return out
            }, {})
        },
        getLockedShipments(state) {
            return state.shipments.filter(s => (s.id > 0) && (s[changedField] < 0)).map(s => s.id)
        },
        getShipments(state) {
            return state.shipments
        },
        getShipmentsWithoutRemoved(state) {
            return state.shipments.filter(s => !s.isRemoved)
        },
        getShipmentsById(state) {
            return state.shipments
                .reduce((shipments, shipment) => {
                    shipments[shipment.id] = shipment
                    return shipments
                }, {})
        },
        getShipmentsByPackageId(state) {
            return state.shipments
                .filter(shipment => shipment.package_id)
                .reduce((shipments, shipment) => {
                    if(!shipments[shipment.package_id]) shipments[shipment.package_id] = []
                    shipments[shipment.package_id].push(shipment)
                    return shipments
                }, {})
        },
    }
}
